import {Modal, Row, Col, Nav, NavDropdown } from 'react-bootstrap';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {useState, useEffect} from 'react'
import { useAppSelector, useAppDispatch } from '../hooks'
import {toggleUserAnalytics } from "../redux/reducers/storageSlice"
import { getBetsByUser } from "../redux/action"
import Identicon from 'react-identicons';
import dayjs from 'dayjs';
import { PieChart } from 'react-minimal-pie-chart';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime)

const columns = [
  {
    dataField: "amount",
    text: "Amount",
    sort: true
  },
  {
    dataField: "multiplier",
    text: "Multiplier",
    sort: true
  },
  {
    dataField: "won",
    text: "Result",
    formatter: (value, row) => {
        let color = "red"
        if (value =="WON") color = "green"
        return (
        <span style={{color: color, fontWeight: 900}}>
          {value}
        </span>
        )    }
  },
  {
    dataField: "createdAt",
    text: "Date",
    formatter: (value, row) => {
        // let dt = new Date(value);
        let timeString = dayjs(value).toNow(true) + " ago."
        // console.log(dt);
        return (

        <span style={{fontWeight: 900}}>
          {timeString}
        </span>
        )    
    }
  },
  {
    dataField: "payoutConfirmation",
    text: "Result TX",
    formatter: (value, row) => {
        // let dt = new Date(value);
        let url = "https://solscan.io/tx/" + value
        // console.log(dt);
        return (

        <span style={{fontWeight: 900}}>
          <a href={url} target="_blank" rel="noopener noreferrer"><img src={"./images/solscan.png"} alt="Solsan TX" style={{height: "20px"}} /></a>
        </span>
        )    
    }    
  }  
];

const UserAnalytics: React.FC = () => {
  const [multiplier, setMultiplier] = useState("All")
  const [amount, setAmount] = useState("All")
  const [period, setPeriod] = useState(30)
  const [token, setToken] = useState("POGR")
  const [loading, setLoading] = useState(true)
  const [chartData, setChartData] = useState([])
  const [analytics, setAnalytics] = useState({p_or_l: 0, totalBets: 0, wins: 0, losses: 0, winStreak: 0})
  const dispatch = useAppDispatch();
  const [bets, setBets] = useState([])
  // const [, setData] = useState({})
  const wallet = useAppSelector(state => state.storage.wallet)
  const userAnalytics = useAppSelector(state => state.storage.userAnalytics)
  const getUserBets = async () => {
    setLoading(true)
    let multiplierVar = multiplier;
    let amountVar = amount
    if (multiplier =="All") multiplierVar = null
    if (amount =="All") amountVar = null
    let data = await getBetsByUser(wallet, multiplierVar, amountVar, token, period);
    setBets(data["bets"])
    // console.log(data)
    setAnalytics({p_or_l: data["p_or_l"], totalBets: data["losses"]+ data["wins"], wins: data["wins"], losses: data["losses"], winStreak: data["winStreak"], rewardPoints: data["rewardPoints"]})
    let chartingData = [{title: "WON", value: data["wins"], color: "green"}, {title: "LOST", value: data["losses"], color: "red"}];
    setChartData(chartingData)
    setLoading(false)
    
  }
    useEffect(() => {
        
        getUserBets(null, null, null, null, period)
        
    }, [wallet, multiplier, amount, token, userAnalytics, period]);

  let multiplierFilterTitle = multiplier+"X Multiplier";
  let tokenFilterTitle = token;
  if (multiplier =="All"){multiplierFilterTitle = "All Multipliers"}
  let amountFilterTitle = amount+" SOL";
  if (amount =="All"){amountFilterTitle = "All Amounts"}    
  let periodFilterTitle = period+" Days";
  return (
    <>
      <Modal show={userAnalytics} size={"xl"} onHide={()=> dispatch(toggleUserAnalytics())}>
        <Modal.Header closeButton>
          <Modal.Title><h5 style={{marginBottom: "0px", fontWeight: "bold", wordBreak: "break-all"}}><Identicon size={20} style={{float: "left"}} string={wallet}/>{wallet}</h5></Modal.Title>
        </Modal.Header>
        <Modal.Body>    
            <Row>         
                <Col>
    <Nav variant="pills" activeKey="1" >
      <Nav.Item>
        <Nav.Link eventKey="3" disabled>
          Filter By
        </Nav.Link>
      </Nav.Item>   
      <NavDropdown id="nav-dropdown" variant="light" title={tokenFilterTitle}  onSelect={(selected) => setToken(selected)} >
        <NavDropdown.Item eventKey={"POGR"}>{"POGR"}</NavDropdown.Item>
        <NavDropdown.Item eventKey={"SOL"}>{"SOL"}</NavDropdown.Item>
      </NavDropdown>
      <NavDropdown id="nav-dropdown" variant="light" title={multiplierFilterTitle} onSelect={(selected) => setMultiplier(selected)} >
        <NavDropdown.Item eventKey={"All"}>All</NavDropdown.Item>
        <NavDropdown.Divider />
        <NavDropdown.Item eventKey={process.env.REACT_APP_MULTIPLIER_1}>{process.env.REACT_APP_MULTIPLIER_1}X</NavDropdown.Item>
        <NavDropdown.Item eventKey={process.env.REACT_APP_MULTIPLIER_2}>{process.env.REACT_APP_MULTIPLIER_2}X</NavDropdown.Item>
        <NavDropdown.Item eventKey={process.env.REACT_APP_MULTIPLIER_3}>{process.env.REACT_APP_MULTIPLIER_3}X</NavDropdown.Item>
        <NavDropdown.Item eventKey={process.env.REACT_APP_MULTIPLIER_4}>{process.env.REACT_APP_MULTIPLIER_4}X</NavDropdown.Item>
      </NavDropdown>
      <NavDropdown id="nav-dropdown" variant="light" title={periodFilterTitle}  onSelect={(selected) => setPeriod(selected)} >
        <NavDropdown.Item eventKey={1}>1 Day</NavDropdown.Item>
        <NavDropdown.Item eventKey={7}>7 Days</NavDropdown.Item>
        <NavDropdown.Item eventKey={30}>30 Days</NavDropdown.Item>
        <NavDropdown.Item eventKey={90}>90 Days</NavDropdown.Item>
      </NavDropdown>         

    </Nav>

                </Col>

            </Row>
            <Row style={{marginTop: 30}}>  
                <Col>     
                    {
                        loading && (bets.length > 0) ? 
                                (
                                  <Col style={{textAlign: "center"}}> 
                                    <img alt="not found" src={"images/loading.gif"} style={{width: "30%"}}/>
                                  </Col> 
                                )
                                :
                                    <div>
                                    <Row>
                                        <Col style={{marginBottom: 50}} md={8}>
                                            <h4 style={{fontWeight: "bold"}}>Recent Plays</h4>
                                            <hr/>
                                                  <BootstrapTable
                                                    bootstrap4
                                                    keyField="id"
                                                    data={bets}
                                                    columns={columns}
                                                    pagination={paginationFactory({ sizePerPage: 8 })}
                                                  />
                                                  
                                        </Col>                                          
                                        <Col style={{marginBottom: 50}} md={4}>
                                            <h4 style={{fontWeight: "600"}}>Reward Points: <span style={{color: "lightgreen", fontWeight: "1000"}}>{analytics.rewardPoints}</span></h4>
                                            <hr/>
                                            <h4 style={{fontWeight: "bold"}}>Analysis</h4>
                                            <hr/>
                                            
                                            <h5 style={{fontWeight: "600", fontSize: 16}}><i className="lni lni-coin" style={{fontWeight: 900}}></i> Total Bets: <span style={{color: "black", fontSize: 18}}>{analytics.totalBets}</span></h5>
                                            <h5 style={{fontWeight: "600", fontSize: 16}}><i className="lni lni-dollar" style={{fontWeight: 900}}></i> P/L: <span style={{color: "black", fontSize: 18}}>{analytics.p_or_l.toFixed(2)} {token}</span></h5>
                                            <h5 style={{fontWeight: "600", fontSize: 16}}><i className="lni lni-list" style={{fontWeight: 900}}></i> Longest Winning Streak: <span style={{color: "black", fontSize: 18}}>{analytics.winStreak} Wins</span></h5>
                                            <h5 style={{fontWeight: "600", fontSize: 16}}><i className="lni lni-list" style={{fontWeight: 900}}></i> Wins: <span style={{color: "green", fontSize: 18}}>{analytics.wins}</span></h5>
                                            <h5 style={{fontWeight: "600", fontSize: 16}}><i className="lni lni-list" style={{fontWeight: 900}}></i> Losses: <span style={{color: "red", fontSize: 18}}>{analytics.losses}</span></h5>
                                            
                                           <PieChart
                                              style={{ height: "40%", marginTop: 20}}
                                                 labelStyle={{
                                                      fill: 'white',
                                                      fontSize: '10px'
                                                 }}
                                              label={({ dataEntry }) => dataEntry.value}
                                              data={chartData}
                                              totalValue={bets.length}
                                            />    

                                        </Col>
                                      
                                    </Row>
                                    </div>  
                    }     
                </Col>
            </Row>     
        </Modal.Body>

      </Modal>
    </>
  );
}

export default UserAnalytics;